// src/components/Recruiter/RecruiterPending.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const RecruiterPending = () => {
    return (
        <div className="container mx-auto px-4 py-16 max-w-2xl">
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
                <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="fas fa-clock text-yellow-600 text-3xl"></i>
                </div>
                <h1 className="text-2xl font-bold text-gradpath-dark mb-2">Application Pending</h1>
                <p className="text-gray-600 mb-4">Your recruiter application has been submitted successfully!</p>
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 text-left">
                    <p className="text-sm text-yellow-800"><i className="fas fa-info-circle mr-2"></i>Your application is pending review. This process typically takes <strong>1-2 business days</strong>.</p>
                    <p className="text-sm text-yellow-800 mt-2"><i className="fas fa-envelope mr-2"></i>If it's been more than 2 business days, please email us at: <a href="mailto:recruiters@gradpath.co.za" className="text-gradpath-green font-medium hover:underline ml-1">recruiters@gradpath.co.za</a></p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to="/" className="px-6 py-2 bg-gradpath-green text-white rounded-lg hover:bg-gradpath-dark transition">Go to Homepage</Link>
                    <button onClick={() => window.location.reload()} className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition">Check Status</button>
                </div>
            </div>
        </div>
    );
};

export default RecruiterPending;